module.exports = __webpack_public_path__ + "static/img/Bachelor_010739.98b1e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010739.jpg
// module id = 239
// module chunks = 0